import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { PalletLoadType } from '../../../types';

export const getPalletLoadTypeListAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetProductPalletLoadType`,
    method: 'get',
  });
};

export type PalletLoadTypeListResponse = {
  disabled: boolean;
  group: null;
  selected: boolean;
  text: PalletLoadType;
  value: PalletLoadType;
}[];

export const fetchPalletLoadTypeList = async (): Promise<PalletLoadTypeListResponse> => {
  const response: AxiosResponse<PalletLoadTypeListResponse> = await getPalletLoadTypeListAPI();
  return response.data;
};
